import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=be879c44&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports